<template>
	<b-container class="m-0 p-0">
		<b-button v-if="status === 'loading'" class="loading">
			<b-spinner label="loading" small></b-spinner>
		</b-button>

		<b-button v-else-if="status === 'error'" class="error">
			<b-icon icon="exclamation-circle" variant="danger"></b-icon>
		</b-button>

		<b-button
			v-else-if="status === 'fetched'"
			class="class text-left px-2"
			:variant="Class.isSignedUp ? 'primary' : isFull ? 'danger' : 'light'"
			@click="Class.isSignedUp ? showCancelModal() : showSignUpModal()"
			:disabled="isFull && !Class.isSignedUp"
		>{{ displayText }}</b-button>
	</b-container>
</template>

<script>
// 6 -> 06
function padWithZero(day) {
	if (day.length === 1) {
		return "0" + day
	} else {
		return day
	}
}

export default {
	name: "Class",
	data() {
		return {
			status: "loading",
			Class: {
				date: "",
				time: "",
				rosterCount: 0,
				isSignedUp: false,
				instructor: {
					id: 0,
					firstName: "",
					lastName: "",
					creds: "",
				}
			},
		}
	},
	props: {
		classID: {
			type: Number,
			required: true,
		},
		lateCx: {
			type: Boolean,
			required: true,
		},
	},
	computed: {
		dateString() {
			return this.Class.date.substr(0, 10)
		},
		timeString() {
			try {
				if (parseInt(this.Class.time.substr(0, 2)) === 12) {
					return this.Class.time.substr(0, 5) + "PM"
				} else if (parseInt(this.Class.time.substr(0, 2)) > 12) {
					// Get hour substring from full time string
					// convert to integer and deduct 12
					// pad with zero if necessary
					// append PM
					return (
						padWithZero(
							(parseInt(this.Class.time.substr(0, 2)) - 12).toString()
						) +
						this.Class.time.substr(2, 3) +
						"PM"
					)
				} else {
					return this.Class.time.substr(0, 5) + "AM"
				}
			} catch {
				return ""
			}
		},
		displayText() {
			try {
				return this.timeString + " with " + this.Class.instructor.firstName
			} catch {
				return "..."
			}
		},
		isFull() {
			if (this.Class.rosterCount === this.max) {
				return true
			} else {
				return false
			}
		},
		isAdmin() {
			return this.$store.getters.isAdmin
		},
		max() {
			return this.$max
		},
	},
	methods: {
		getClassDetails: function() {
			return new Promise((resolve, reject) => {
				fetch(this.$apiURL + "/classDetails", {
					method: "POST",
					body: JSON.stringify({
						classID: this.classID,
					}),
					headers: new Headers({
						Authorization: this.$store.state.token,
						"Content-Type": "application/json",
					}),
				}).then(res => {
					if (res.ok) {
						res.json().then(Class => {
							this.Class = Class
							resolve()
						})
					} else if (res.status === 401) {
						this.$store.dispatch("logout").then(() => {
							this.$router.push("/Login")
							reject(res)
						})
					} else {
						reject(res)
					}
				})
			})
		},
		cancelClass: function() {
			if (this.lateCx) {
				alert(
					"Class reservations must be cancelled by 4PM on the previous day."
				)
			} else {
				return new Promise((resolve, reject) => {
					fetch(this.$apiURL + "/removeUserFromClass", {
						method: "POST",
						headers: new Headers({
							Authorization: this.$store.state.token,
							"Content-Type": "application/json",
						}),
						body: JSON.stringify({
							classID: this.classID,
						}),
					}).then(res => {
						if (res.ok) {
							this.status = "loading"
							this.updateClass()
								.then(() => {
									this.status = "fetched"
								})
								.then(() => {
									alert("Class registration cancelled")
								})
							resolve()
						} else if (res.status === 401) {
							this.$store.dispatch("logout").then(() => {
								this.$router.push("/Login")
								reject(res)
							})
						} else {
							this.status = "loading"
							this.updateClass()
								.then(() => {
									this.status = "fetched"
								})
								.then(() => {
									alert("An error has occured, please try again.")
								})
							resolve()
						}
					})
				})
			}
		},
		signUpForClass: function() {
			return new Promise((resolve, reject) => {
				fetch(this.$apiURL + "/addUserToClass", {
					method: "POST",
					headers: new Headers({
						Authorization: this.$store.state.token,
						"Content-Type": "application/json",
					}),
					body: JSON.stringify({
						classID: this.classID,
					}),
				}).then(res => {
					if (res.ok) {
						this.status = "loading"
						this.updateClass()
							.then(() => {
								this.status = "fetched"
							})
							.then(() => {
								alert("Signed up for class")
							})
						resolve()
					} else if (res.status === 401) {
						this.$store.dispatch("logout").then(() => {
							this.$router.push("/Login")
							reject(res)
						})
					} else {
						this.status = "loading"
						this.updateClass()
							.then(() => {
								this.status = "fetched"
							})
							.then(() => {
								alert("An error has occured, please try again.")
							})
						resolve()
					}
				})
			})
		},
		updateClass: function() {
			return new Promise((resolve, reject) => {
				fetch(this.$apiURL + "/classDetails", {
					method: "POST",
					body: JSON.stringify({
						classID: this.classID,
					}),
					headers: new Headers({
						Authorization: this.$store.state.token,
						"Content-Type": "application/json",
					}),
				}).then(res => {
					if (res.ok) {
						res.json().then(Class => {
							// Only overwrite current class data if new data is different
							if (this.Class === Class) {
								resolve()
							} else {
								this.Class = Class
								resolve()
							}
						})
					} else if (res.status === 401) {
						this.$store.dispatch("logout").then(() => {
							this.$router.push("/Login")
							reject(res)
						})
					} else {
						reject(res)
					}
				})
			})
		},
		showSignUpModal: function() {
			this.$bvModal.msgBoxConfirm(
				`Sign up for class on ${this.dateString} @ ${this.timeString}?`,
				{
					title: "Confirm sign up",
					size: "md",
					buttonSize: "md",
					okVariant: "primary",
					okTitle: "Sign Up",
					cancelTitle: "Back",
					footerClass: "p-2",
					hideHeaderClose: false,
					centered: true,
				}
			)
				.then(async value => {
					if (value) {
						await this.signUpForClass()
					}
				})
		},
		showCancelModal: function() {
			this.$bvModal.msgBoxConfirm(
				`Cancel class on ${this.dateString} @ ${this.timeString}?`,
				{
					title: "Confirm cancellation",
					size: "md",
					buttonSize: "md",
					okVariant: "danger",
					okTitle: "Cancel",
					cancelTitle: "Back",
					footerClass: "p-2",
					hideHeaderClose: false,
					centered: true,
				}
			)
				.then(async value => {
					if (value) {
						await this.cancelClass()
					}
				})
		},
	},
	created() {
		this.getClassDetails().then(() => {
			this.status = "fetched"
		})
	},
}
</script>

<style scoped>
.error,
.loading,
.class {
	display: block;
	margin: 8px auto;
	width: 100%;
}
</style>
